import { authorizationApi } from "../api/authorization";
import { apiRequestBase, unwrapResponse } from "../api/client";
import { env } from "../config/env";

export interface BusinessProfile {
  id: string;
  name: string;
  plan?: string;
  status?: boolean | string;
  email?: string;
  raw: any;
}

// Data that belongs to one business; cleared when the user checks in to a different one
const PROFILE_SCOPED_KEYS = [
  "businessDetails",
  "outlet",
  "outletSession",
  "outletSessionInfo",
  "counter",
  "counterSession",
  "counterCheckedInInfo",
  "pendingCheckedInOutlet",
  "warehouseId",
];

export function getUserEmail(user: any): string {
  const profile = user?.profile ?? {};
  return profile.email || profile.Email || profile.upn || "";
}

export function mapBusinessProfile(item: any): BusinessProfile {
  return {
    id: String(
      item?.businessProfile?.id ??
        item?.businessProfileId ??
        item?.businessProfileID ??
        item?.BusinessProfileId ??
        item?.id ??
        "",
    ),
    name:
      item?.businessProfile?.name ??
      item?.businessName ??
      item?.name ??
      item?.Name ??
      "Business",
    plan:
      item?.subscriptionPlan?.name ??
      item?.packageName ??
      item?.planName ??
      item?.PlanName,
    status: item?.subscriptionStatus ?? item?.status ?? item?.Status,
    email: item?.userMail ?? item?.email ?? item?.Email,
    raw: item,
  };
}

export function isProfileActive(profile: BusinessProfile): boolean {
  return profile.status === undefined || profile.status === true || profile.status === "Active";
}

export async function fetchBusinessProfiles(email: string): Promise<BusinessProfile[]> {
  const response = await authorizationApi.getBusinessProfilesByEmail(email);
  const data = unwrapResponse<any[]>(response);
  return Array.isArray(data) ? data.map(mapBusinessProfile) : [];
}

async function fetchAndStoreBusinessDetails() {
  const data = await apiRequestBase<unknown>(
    env.sharedConfigBaseUrl,
    "/CompanySetting/Details",
  );
  localStorage.setItem("businessDetails", JSON.stringify(data));
}

// Same as Check In on the web panel selection: store the profile, then load its business details
export async function checkInToProfile(profile: BusinessProfile) {
  const previousProfileId = localStorage.getItem("profileId");
  if (previousProfileId && previousProfileId !== profile.id) {
    PROFILE_SCOPED_KEYS.forEach((key) => localStorage.removeItem(key));
  }

  localStorage.setItem("biznifyBusinessProfile", JSON.stringify(profile));
  localStorage.setItem("clientBusinessProfile", JSON.stringify(profile.raw));
  if (profile.id) {
    localStorage.setItem("profileId", profile.id);
  }
  const rawUserId = profile.raw?.userId ?? profile.raw?.UserId;
  if (rawUserId != null) {
    localStorage.setItem("userId", String(rawUserId));
  }

  try {
    await fetchAndStoreBusinessDetails();
  } catch {
    // Non-fatal: business details fetch failed
  }
}
